export enum PublicApiVendorEnum {
    PHOTO_SENTINEL = 'PHOTO_SENTINEL',
}
